import { IPublicClientApplication } from "@azure/msal-browser";
import Button from "../../button/Button";
import { useDispatch } from "react-redux";


function SignOutButton(props:{instance: IPublicClientApplication}) {

  const dispatch = useDispatch();

  function handleLogout(){
    dispatch({type:"RESET"});
    props.instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }

  return (
    <div>
      <Button
        onClick={handleLogout}
        className="header-principal-cesion-button"
      >
        Cerrar sesión
      </Button>
    </div>
  );
}

export default SignOutButton;
